<template>


        <el-card class="page-content" shadow="never">
            <div class="page-actions">
                <!--分页表单-->
                <el-form inline>

                    <el-form-item label="工单状态：">
                        <el-select v-model="formInline.status" placeholder="工单状态">
                            <el-option key="" label="全部"  value=""></el-option>
                            <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                            ></el-option>

                        </el-select>
                    </el-form-item>

                    <el-form-item label="提交人："   >
                        <el-input v-model="formInline.submitUser" placeholder="提交人"></el-input>
                    </el-form-item>

                    <el-form-item label="处理人："   >
                        <el-input v-model="formInline.handleUser" placeholder="处理人"></el-input>
                    </el-form-item>

                    <el-form-item label="开始时间：" prop="earliestBidTime">
                        <el-date-picker
                                v-model="formInline.beginTime"
                                type="datetime"
                                placeholder="开始时间"
                        ></el-date-picker>
                    </el-form-item>

                    <el-form-item label="结束时间：" prop="earliestBidTime">
                        <el-date-picker
                                v-model="formInline.endTime"
                                type="datetime"
                                placeholder="结束时间"

                        ></el-date-picker>
                    </el-form-item>

                    <el-form-item >
                        <el-button type="primary" @click="getWorkData(formInline)">搜索</el-button>
                    </el-form-item>

                    <div class="preview-opration">
                        <el-button type="primary" @click="openCreateDialog">新增
                        </el-button>
                    </div>
                </el-form>

            </div>
            <!-- 数据列表-->
            <div class="sweep-list">
                <el-table class="sweep-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                          :data="dataList" :row-key="() => Math.random()">
                    <el-table-column prop="id" label="ID"></el-table-column>
                    <el-table-column prop="submitUser" label="提交人"></el-table-column>
                    <el-table-column prop="handleUser" label="处理人" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="questionDescribe" label="问题描述" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="platform" label="平台" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="feedbackAccount" label="反馈用户账号" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="computerSystem" label="电脑系统" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="browser" label="浏览器" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="phoneType" label="手机型号" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="systemVersion" label="系统版本" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="appVersion" label="app版本" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="network" label="网络环境"></el-table-column>
                    <el-table-column prop="networkLine" label="线路" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="tbNum" label="TB号" show-overflow-tooltip > </el-table-column>
                    <el-table-column prop="resourcesJson" label="附件" show-overflow-tooltip >
                        <template scope="scope">
                            <el-button v-if="scope.row.resourcesJson!=''" @click="showImage(scope.row.resourcesJson)"  type="primary" size="small">查看</el-button>

                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="100" >
                        <template slot-scope="scope" >
                            <span>{{scope.row.answerStatus | formatStatus}} </span>
                            <i v-show="!isQa"
                                    @click="showStatusUpdate('statusVisible', scope.row.id, scope.row.answerStatus)"
                                    class="el-icon-edit"
                            ></i>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.createTime | moment}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="更新时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.updateTime | moment}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">

                            <el-button v-if="showUser(scope.row)"  @click="updateWorkDialog(scope.row)"  type="primary" size="small">编辑详情 </el-button>

                            <el-button  v-if="showDel(scope.row)"  @click="deleteRecord(scope.row)" type="danger" size="small">删除</el-button>


                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination style="margin-top: 30px"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="queryParams.page"
                               :page-sizes="[10, 20, 50, 100]"
                               :page-size="queryParams.size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total">
                </el-pagination>

            </div>
            <el-dialog title="附件" :visible.sync="dialogImage" width="30%" @close="clearAddData"
                       :close-on-click-modal="false">

                <div v-for = "(item,index)  in addData.urls">
                    <div class="resours" v-if="matchType(item ) == 'image'">
                        <img width="100%" height="500px"  :src="item"/>
                        <div class="ahref" >
                            <a class="aimage" :href="item" target="_blank" > <i class=" el-icon-view">查看</i> </a>&nbsp;&nbsp;
                        </div>
                    </div>
                    <div class="resours" v-if="matchType(item ) == 'video'">
                        <video controls width="100%" height="500px">
                            <source :src="item" type="video/mp4">
                        </video>
                        <div class="ahref">
                            <a  class="aimage":href="item" target="_blank"> <i class=" el-icon-view">查看</i> </a>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" @close="clearData"
                       :close-on-click-modal="false">
                <el-form label-width="120px">

           <!--         <el-form-item label="提交人">
                        <el-input placeholder="请输入提交人" v-model="addData.submitUser" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item label="处理人">
                        <el-input placeholder="处理人" v-model="addData.handleUser" style="width: 80%"></el-input>
                    </el-form-item>-->
                    <el-form-item :required ="true" label="平台">
                        <el-select v-model="addData.platform">
                            <el-option
                                    v-for="item in SYSTEM"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :required ="true" label="反馈用户账号："   >
                        <el-input  placeholder="反馈用户账号" v-model="addData.feedbackAccount" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item :required ="true" label="电脑系统：" v-if="addData.platform == '网页'"   >
                        <el-input placeholder="电脑系统" v-model="addData.computerSystem" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item :required ="true" label="浏览器："  v-if="addData.platform == '网页'" >
                        <el-input placeholder="浏览器" v-model="addData.browser" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item  :required ="true" label="手机型号：" v-if="addData.platform != '网页'"  >
                        <el-input placeholder="手机型号" v-model="addData.phoneType" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item :required ="true" label="系统版本："  v-if="addData.platform != '网页'" >
                        <el-input placeholder="系统版本" v-model="addData.systemVersion" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item :required ="true" label="app版本："  v-if="addData.platform != '网页'" >
                        <el-input placeholder="app版本" v-model="addData.appVersion" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item :required ="true" label="网络环境">
                        <el-input placeholder="网络环境"  v-model="addData.network" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item :required ="true" label="线路" v-if="addData.platform != '网页'">
                        <el-input placeholder="线路" v-model="addData.networkLine" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item label="TB号" >
                        <el-input placeholder="TB号" v-model="addData.tbNum" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item :required ="true" label="问题描述">
                        <el-input placeholder="问题描述" v-model="addData.questionDescribe" style="width: 80%" type="textarea" ></el-input>
                    </el-form-item>
                    <el-form-item label="回复" v-if="currOpration!=1">
                        <el-input placeholder="回复"  v-model="addData.answer" style="width: 80%" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="附件">

                        <div v-for = "(item,index)  in addData.urls">
                            <div class="resours" v-if="matchType(item ) == 'image'">
                                <img width="30%" height="50%"  :src="item"/>
                                <div class="ahref">
                                    <a :href="item" target="_blank"> <i class=" el-icon-view">查看</i> </a>
                                    &nbsp;&nbsp;
                                    <a @click="remove(item,index)"><i class="el-icon-delete">删除</i></a>
                                </div>
                            </div>
                            <div class="resours" v-if="matchType(item ) == 'video'">
                                <video controls width="30%" height="50%">
                                    <source :src="item" type="video/mp4">
                                </video>
                                <div class="ahref">
                                    <a :href="item" target="_blank"> <i class=" el-icon-view">查看</i> </a>
                                    &nbsp;&nbsp;
                                    <a @click="remove(item,index)"><i class="el-icon-delete">删除</i></a>
                                </div>


                            </div>
                        </div>

                    </el-form-item>

                    <el-form-item label="视频图片附件">
                        <div style="margin-top: 20px">
                            <upload v-model="resourcesUrl" multiple :limit="10"
                                    ref="childUpload"/>

                        </div>

                    </el-form-item>
                </el-form>


                <span slot="footer" class="dialog-footer">
                  <el-button type="danger" :loading="loading" @click="addWork">确 定</el-button>
                </span>
            </el-dialog>

            <div class="cycle-status">
                <el-dialog :visible.sync="statusVisible" title="修改状态" width="30%" >
                    <el-select v-model="status">
                        <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        ></el-option>
                    </el-select>
                    <div class="btn-wrap">
                        <el-button @click="handleUpdateStatus()" type="success">提交</el-button>
                    </div>
                </el-dialog>
            </div>

        </el-card>
</template>

<script>
    import api from "../api";
    import upload from "../../../../components/upload/indexMultiple";
    import userInfoHelper from 'common/userInfo';
    export const STATUS = ['未处理', '已回复', '修复中', '已修复'];
    export default {
        name: 'work',
        components: {
            upload
        },
        data() {
            return {
                isQa : false,
                loading:false,
                resourcesUrl:[],
                id:'',
                status:0,
                dataList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    page: 1,
                    size: 10,
                    userName: "",
                },
                formInline: {
                    submitUser: '',
                    handleUser: '',
                    userId:'',
                    beginTime:'',
                    endTime:'',
                    status:''
                },
                dialogVisible: false, //对话框是否显示
                dialogImage:false,//图片对话框
                statusVisible:false,//修改状态对话框
                isRouterAlive: true,
                dialogTitle: '添加',
                currOpration: "1", //1-新增，2-修改 3-详情
                addData: {
                    id:null,
                    submitUser: '',
                    handleUser: '',
                    userName:'',
                    platform:'',
                    network:'',
                    networkLine:'',
                    answerStatus:0,
                    tbNum:'',
                    questionDescribe:'',
                    answer:'',
                    resourcesJson:'',
                    userId:'',
                    beginTime:'',
                    endTime:'',
                    urls:[],
                },
                SYSTEM: ['安卓', '苹果', '网页'],
                statusList:
                    [
                        {
                            value: 0,
                            label: STATUS[0]
                        },
                        {
                            value: 1,
                            label: STATUS[1]
                        },
                        {
                            value: 2,
                            label: STATUS[2]
                        },
                        {
                            value: 3,
                            label: STATUS[3]
                        },
                    ],
            }
        },
        filters: {
            /*  状态0未处理,1已回复,2修复中,3已修护*/
            formatStatus(answerStatus) {
                return STATUS[answerStatus];
            }
        },
        methods: {
            getWorkData(query) {
                let  userName = this.$parent.getUserName();
                this.isQa = userName==null?false:true
                //query.userName = userName;
                api.getWorkPage(query).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },

            remove(item,index) {
                console.info(item);
                this.addData.urls.splice(index,1);
                this.$forceUpdate();
            },
            handleSizeChange(val) {

                this.queryParams.size = val;
                this.getWorkData(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getWorkData(this.queryParams);
            },
            openCreateDialog() {
                this.currOpration =1
                this.dialogTitle = '添加'
                this.clearAddData()
                this.dialogVisible = true;
            },

            clearData() {

                this.$refs.childUpload.clearFiles();
                this.clearAddData();
            },
            clearAddData(){
                this.addData = {
                    id: null,
                    submitUser: '',
                    handleUser: '',
                    platform: '',
                    feedbackAccount:'',
                    computerSystem:'',
                    browser:'',
                    phoneType:'',
                    systemVersion:'',
                    appVersion:'',
                    network: '',
                    networkLine: '',
                    answerStatus: 0,
                    tbNum: '',
                    questionDescribe: '',
                    answer: '',
                    resourcesJson: '',
                    userId: '',
                    beginTime: '',
                    endTime: '',
                    line:'',
                    urls:[],
                }

            },
            addWork() {

                if (this.addData.platform == "") {
                    this.$message.error('请输入平台');
                    return;
                }

                if (this.addData.feedbackAccount == "") {
                    this.$message.error('请输入反馈用户账号');
                    return;
                }

                if(this.addData.platform == "网页"){
                    if(this.addData.computerSystem == "" ||  this.addData.browser == ""){
                        this.$message.error('网页端,浏览器、电脑系统必须填写');
                        return;
                    }
                }
                if(this.addData.platform == "安卓"||this.addData.platform == "苹果" ){
                    if(this.addData.phoneType == "" ||  this.addData.systemVersion == ""|| this.addData.appVersion=="" ||this.addData.networkLine==""){
                        this.$message.error('手机端,手机型号、系统版本、app版本、线路必须填写');
                        return;
                    }
                }

                if (this.addData.network == "") {
                    this.$message.error('请输入网络环境');
                    return;
                }

                if (this.addData.questionDescribe == "") {
                    this.$message.error('请输入问题描述');
                    return;
                }

                if(this.resourcesUrl!=null){
                    this.addData.urls.push(this.resourcesUrl)

                }
                if(this.currOpration==1){
                    let user = userInfoHelper.get()
                    this.addData.userName=user.userName
                }
                let str =this.addData.urls.join(",")
                this.addData.resourcesJson = (str.substring(str.length - 1) == ',') ? str.substring(0, str.length - 1) : str;

                api.updateWork(this.addData).then(({data}) => {
                    this.$message.success(this.dialogTitle+'成功!');
                    this.getWorkData(this.queryParams);
                    this.dialogVisible = false;
                    this.loading = false;

                });
            },
            showUser(row){
                let userName = this.$parent.getUserName();
                if (userName==null){
                    return true;
                }
                return row.userName==this.$parent.getUserName();
            },
            showDel(row){
                let b =  this.$parent.isDevelop();
                if(b){
                    return false;
                }else{
                    return  this.showUser(row);
                }
            },
            updateWorkDialog(row) {
                this.currOpration =2
                this.dialogTitle = '修改'
                this.addData = row;
                if( this.addData.resourcesJson!='') {
                    this.addData.urls = this.addData.resourcesJson.split(',')
                }else{
                    this.addData.urls=[];
                }
                this.dialogVisible = true;

            },
            deleteRecord(data) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    api.delWork(data).then((response) => {
                        if (response.data === true) {
                            this.dialogVisible = false;
                            this.$message.success('删除成功');
                            this.getWorkData(this.queryParams);
                        } else {
                            this.$message.error('删除失败')
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            showImage( val) {
                console.info(val)
                if( val!='') {
                    this.addData.urls = val.split(',')
                    console.info(this.addData.urls)

                }else{
                    this.addData.urls=[];
                }
                this.dialogImage = true;

            },
            showStatusUpdate(type, id, val) {
                this.id = id;
                this.status = val;
                this.statusVisible = true;
            },
            handleUpdateStatus() {
                api.updateWorkStatus({
                    id: this.id,
                    status: this.status
                }).then(res => {
                    this.$message({
                        message: "修改成功！",
                        type: "success"
                    });
                    this.statusVisible = false;
                    this.getWorkData(this.queryParams);

                });
            },

            matchType(fileName) {
                // 后缀获取
                var suffix = '';
                // 获取类型结果
                var result = '';
                try {
                    var flieArr = fileName.split('.');
                    suffix = flieArr[flieArr.length - 1];
                } catch (err) {
                    suffix = '';
                }
                // fileName无后缀返回 false
                if (!suffix) {
                    result = false;
                    return result;
                }
                // 图片格式
                var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
                // 进行图片匹配
                result = imglist.some(function (item) {
                    return item == suffix;
                });
                if (result) {
                    result = 'image';
                    return result;
                };
                // 匹配 视频
                var videolist = ['mp4', 'm2v', 'mkv'];
                result = videolist.some(function (item) {
                    return item == suffix;
                });
                if (result) {
                    result = 'video';
                    return result;
                };
                // 其他 文件类型
                result = 'other';
                return result;
            },
        },
        created() {
            this.getWorkData(this.queryParams);
        },

    };
</script>

<style lang="less" scoped>
    .resours{
        height:30%;
    }

    .ahref {
        margin-top: 10px;
        height:30px;
    }
    .aimage{
        float: right;
    }
    .btn-wrap {
        margin-top: 30px;
    }
    .el-icon-edit {
        color: #409eff;
        cursor: pointer;
    }

</style>
